import React from 'react';
import { statusToString, statusToStringSpanish } from '../helpers/appointment';

const statusStyles = {
  0: "bg-Scheduled text-white", // Scheduled
  1: "bg-Show text-white", // Show
  2: "bg-Noshow text-white", // No-show
  3: "bg-black text-white", // Cancelled
  4: "bg-Rescheduled text-white" // Rescheduled
};

const StatusTag = ({ status, language }) => {
  return (
    <div className={`items-center gap-2 px-3 py-1 rounded-lg w-fit ${statusStyles[status]}`}>
      <p className="font-medium">
        {language === "English" ? statusToString(status) : statusToStringSpanish(status)}
      </p>
    </div>
  );
};

export default StatusTag;
